export default __webpack_public_path__ + "static/media/denise-artworkinfo2.e52b3e83.jpeg";